var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivityHistoryFilterScreenViews = function SvgActivityHistoryFilterScreenViews(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19344_59074)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.0785 8.31134C1.97383 8.11734 1.97383 7.882 2.0785 7.688C3.33983 5.35534 5.66983 3.33334 7.99984 3.33334C10.3298 3.33334 12.6598 5.35534 13.9212 7.68867C14.0258 7.88267 14.0258 8.118 13.9212 8.312C12.6598 10.6447 10.3298 12.6667 7.99984 12.6667C5.66983 12.6667 3.33983 10.6447 2.0785 8.31134V8.31134Z",
    stroke: "#8E8E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41421 6.58579C10.1953 7.36684 10.1953 8.63317 9.41421 9.41422C8.63316 10.1953 7.36683 10.1953 6.58578 9.41422C5.80474 8.63317 5.80474 7.36684 6.58578 6.58579C7.36683 5.80475 8.63316 5.80475 9.41421 6.58579Z",
    stroke: "#8E8E93",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19344_59074"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
export { SvgActivityHistoryFilterScreenViews as ReactComponent };
export default __webpack_public_path__ + "activity-history-filter-screen-views.svg";